import axios from 'axios';
import { SERVER_URL } from '../App';

function jsonConfig(withCredentials = false) {
    return {
        withCredentials,
        headers: { 'Content-Type': 'application/json' },
    };
}

export async function interpretAiDraft(payload) {
    const { data } = await axios.post(
        `${SERVER_URL()}ai/interpret`,
        payload,
        jsonConfig(false),
    );
    return data;
}

export async function createAiBuildClaim(payload) {
    const { data } = await axios.post(
        `${SERVER_URL()}ai/build-claims`,
        payload,
        jsonConfig(false),
    );
    return data;
}

export async function claimAiBuild(claimToken) {
    const { data } = await axios.post(
        `${SERVER_URL()}ai/claim-build`,
        { claim_token: claimToken },
        jsonConfig(true),
    );
    return data?.build;
}
